<div [class]="overlaySlotClass" [blazeSlotNode]="slots?.slotNodesData?.main">
  <ng-container *ngTemplateOutlet="slots?.templates?.main || null" />
</div>
